module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Ym94PSIwIDAgMTggMTgiPgogIDxwYXRoIGNsYXNzPSJxbC1maWxsIiBkPSJNMTUsOEgxM2ExLDEsMCwwLDEsMC0yaDJBMSwxLDAsMCwxLDE1LDhaIi8+CiAgPHBhdGggY2xhc3M9InFsLWZpbGwiIGQ9Ik0xNSwxMkgxM2ExLDEsMCwwLDEsMC0yaDJBMSwxLDAsMCwxLDE1LDEyWiIvPgogIDxwYXRoIGNsYXNzPSJxbC1maWxsIiBkPSJNMTUsMTZINWExLDEsMCwwLDEsMC0ySDE1QTEsMSwwLDAsMSwxNSwxNloiLz4KICA8cGF0aCBjbGFzcz0icWwtZmlsbCIgZD0iTTE1LDRINUExLDEsMCwwLDEsNSwySDE1QTEsMSwwLDAsMSwxNSw0WiIvPgogIDxyZWN0IGNsYXNzPSJxbC1maWxsIiB4PSIyIiB5PSI2IiB3aWR0aD0iOCIgaGVpZ2h0PSI2IiByeD0iMSIgcnk9IjEiLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/quill/assets/icons/float-left.svg
// module id = xWd9
// module chunks = 4